<template>
    <div class="main">
        <c-panel>
            <assinaturas></assinaturas>
        </c-panel>
    </div>
</template>
<script>

import assinaturas from "./assinaturas"

export default {
    components:{ assinaturas }
}
</script>
